/*
 * constants.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Feb 02 2023 mys Company
 */

import * as mysUtilities from '../../utilities/mysUtilities'

let mode = 'production' // local,develop,production
export const BASE_URL = mode === 'local' ? 'http://localhost:8064/api/' : mode === 'develop' ? 'http://localhost:8062/api/' : 'https://api.usefpour.com/api/'

export const setUserId = (id) => {
    mysUtilities.setStorage('user', String(id))
}
export const getUserId = () => {
    return mysUtilities.getStorage('user') ?? ''
}

export const setToken = (token) => {
    mysUtilities.setStorage('token', String(token))
}
export const getToken = () => {
    return mysUtilities.getStorage('token') ?? ''
}

export const setServerDate = (date) => {
    mysUtilities.setStorage('serverDate', String(date))
}
export const getServerDate = () => {
    return mysUtilities.getStorage('serverDate') ?? ''
}

export const setIsExpert = (flag) => {
    mysUtilities.setStorage('isExpert', flag)
}
export const getIsExpert = () => {
    return mysUtilities.getStorage('isExpert') ?? false
}

export const setMenus = (json) => {
    mysUtilities.setStorage('menus', json)
}
export const getMenus = () => {
    if (mysUtilities.getStorage('menus')) {
        return JSON.parse(mysUtilities.getStorage('menus'))
    } else {
        return []
    }
}

export const setLastMenuClicked = (json) => {
    mysUtilities.setStorage('lastMenuClicked', JSON.stringify(json))
}
export const getLastMenuClicked = () => {
    if (mysUtilities.getStorage('lastMenuClicked')) {
        return JSON.parse(mysUtilities.getStorage('lastMenuClicked'))
    } else {
        return {}
    }
}

export const setPermissions = (json) => {
    mysUtilities.setStorage('permissions', json)
}
export const getPermissions = () => {
    if (mysUtilities.getStorage('permissions')) {
        return JSON.parse(mysUtilities.getStorage('permissions'))
    } else {
        return []
    }
}

export const setStates = (flag) => {
    mysUtilities.setStorage('cities', flag)
}
export const getStates = () => {
    if (mysUtilities.getStorage('cities')) {
        return JSON.parse(mysUtilities.getStorage('cities'))
    } else {
        return []
    }
}
